import React, { useContext, useState, ToastAndroid, useEffect } from "react";
import { getStoreInvoicePrinter, getUserData } from "../../utils/localStorage";
import { useLocation, useNavigate } from "react-router-dom";
import StoreMenu from "../StoreMenu";

import qz from "qz-tray";
import ButtonLink from "../../ButtonLink";
import { getCustomerOrders } from "../../services/CustomerInfo/CustomerInfo";

const OrderDeliveredComponentMenu = () => {
  const { storeData, brandProfileData, userProfileData } = getUserData();

  let store = storeData;
  let storeId = storeData.id;
  let brand = brandProfileData;
  const userProfile = userProfileData;

  const location = useLocation();
  const { customerOrdersData } = location.state || {}; // Fallback to prevent undefined errors

     const [customerALLOrdersData, setCustomerALLOrdersData] =
       useState(customerOrdersData);

    // const fetchCustomerOrders = async () => {
         
    //     const data = {
    //       offset: 0,
    //       limit: 1000,
    //       statusIn: [
    //           "DELIVERED",
    //       ]
    //     }
    //     try {
    //       const response = await getCustomerOrders(storeCustomerId, storeId, data);
    //       if (!response.data.error) {
    //         setCustomerALLOrdersData(response.data);
             
    //       }
    //     } catch (error) {
    //       console.error("Error:", error);
    //     }
    //   };

  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const data = {
    storeName: store.storeName,
    brandName: brand.name,
    fullAddress: store.address.fullAddress,
    mobileNumber: store.mobileNo,
    email: store.email,
    
    orderItems: customerALLOrdersData.map((item) => ({
      paidAmount: item.paidAmount,
    billNo: item.invoiceNo,
    balanceAmount: item.balanceAmount,
    customerName: item.customerName
    })),
  };

  const [isConnected, setIsConnected] = useState(false);

  const connectToQZ = async () => {
    try {
      if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
        setIsConnected(true);
      }
    } catch (err) {
      console.error("Connection error:", err);
    }
  };

  const [invoicePrinterValue, setInvoicePrinterValue] = useState("");
  const fetchSelectedInvoicePrinter = async () => {
    try {
      const selectedInvoicePrinterData = await getStoreInvoicePrinter();
      setInvoicePrinterValue(selectedInvoicePrinterData?.invoicePrinter || "");
    } catch {
      setInvoicePrinterValue("");
    }
  };

  useEffect(() => {
    if(!isConnected) 
      {
        connectToQZ();
      }

    fetchSelectedInvoicePrinter()
    // fetchCustomerOrders();
  }, [])
  
  const printInvoiceHTML = async () => {
    try {
      // const printer = await qz.printers.find("POS80 Printer"); // Adjust to your printer's actual name
      const printer = await qz.printers.find(invoicePrinterValue);
      const config = qz.configs.create(printer, {
        encoding: "UTF-8",
        size: { width: 3 },
        units: "in",
        density: "600",
        colorType: "grayscale",
      });

      const orderItemsHtml = data.orderItems
        .map((item) => {
          const billNo = item.billNo;
          const customerName = item.customerName
          const paidAmount = item.paidAmount
          const balanceAmount = item.balanceAmount;

          return `
      <div style="display: flex;">
        <p style="flex: 1; font-size: 12px; margin: 0; text-align: left;">${billNo}</p>
        <p style="flex: 2; font-size: 12px; margin: 0; text-align: left;">${customerName}</p>
        <p style="flex: 1; font-size: 12px; margin: 0; text-align: right;">${paidAmount}</p>
        <p style="flex: 1; font-size: 12px; margin: 0; text-align: right;">${balanceAmount}</p>
      </div>
    `;
        })
        .join("");

      const htmlContent = `
      <html>
        <body style="font-size: 12px; font-family: sans-serif;">
          <div style="text-align: center;">
            <span style="font-size: 18px; font-weight: bold;">Delivered Order</span>
            <hr style="border-top: 1px dashed #000;"/>
            <p style="font-size: 14px; font-weight: bold; margin: 0;">${data.storeName}</p>
            <p style="font-size: 12px; margin: 0;">${data.fullAddress}</p>
            <p style="font-size: 12px; margin: 0;">${data.mobileNumber}</p>
            <p style="font-size: 12px; margin: 0;">${data.email}</p>
            <hr style="border-top: 1px dashed #000;"/>
            <div style="display: flex;">
              <p style="flex: 1; font-weight: bold; margin: 0; text-align: left;">Bill No.</p>
              <p style="flex: 2; font-weight: bold; margin: 0; text-align: left;">Customer</p>
              <p style="flex: 1; font-weight: bold; margin: 0; text-align: right;">Paid</p>
              <p style="flex: 1; font-weight: bold; margin: 0; text-align: right;">Bal</p>
            </div>
            ${orderItemsHtml}
              <div style="display: flex; justify-content: space-between;">
              <span><strong>Total Garments:</strong></span>
              <span><strong>${data.orderItems.length}</strong></span>
            </div>
            <hr style="border-top: 1px dashed #000;"/>
            <p style="font-size: 16px; font-weight: bold;">Powered By ${data.brandName}</p>
          </div>
        </body>
      </html>
    `;

      await qz.print(config, [
        { type: "html", format: "plain", data: htmlContent },
      ]);
      // alert("HTML receipt sent to printer!");
    } catch (err) {
      console.error("Print failed:", err);
      alert("Failed to print receipt");
    }
  };

 

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => {
                      navigate("/OrderDelivered")
                  }}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
              Delivered Order
              </p>
            </div>
            <div className="flex">
              <div
                className="mx-4 cursor-pointer"
                onClick={printInvoiceHTML}
              >
                <img
                  src={"images/printer.png"}
                  style={{
                    width: 35,
                  }}
                />
              </div>
            </div>
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="flex justify-content-between mt-2">
        <div></div>
        <div className="w-5 ">
          <div className="flex justify-content-center flex-column print-section">
            <p className="text-3xl font-medium text-center">Delivered Order</p>
            <div className="flex justify-content-center align-items-center">
              <p className="w-7  border-dashed border-1 "></p>
            </div>
            <p className="text-xl font-medium text-center">{data.storeName}</p>
            <p className="text-lg font-normal text-center">
              {data.fullAddress}
            </p>
            <p className="text-lg font-normal text-center">
              {data.mobileNumber}
            </p>
            <p className="text-lg font-normal text-center">{data.email}</p>
            <div className="flex justify-content-center align-items-center">
              <p className="w-5  border-dashed border-1 "></p>
            </div>
            <div className="flex">
              <p className="text-lg font-medium text-left" style={{ flex: .7 }}>
                Bill No.:
              </p>
              <p className="text-lg font-medium text-left" style={{ flex: 1 }}>
              Customer
              </p>
              <p className="text-lg font-medium text-right" style={{ flex: .5 }}>Paid</p>
              <p className="text-lg font-medium text-right" style={{ flex: .5 }}>Bal</p>
            </div>
            {data.orderItems.map((item) => (
              <div className="flex " key={item.billNo}>
                <p
                  className="text-lg font-normal text-left"
                  style={{ flex: .7 }}
                >
                  {item.billNo}
                </p>
                <p
                  className="text-lg font-normal text-left"
                  style={{ flex: 1 }}
                >
                   {item.customerName}
                </p>
                <p
                  className="text-lg font-normal text-right" style={{ flex: .5 }}
                >
                   {item.paidAmount}
                </p>
                <p className="text-lg font-normal text-right" style={{ flex: .5 }}>
                {item.balanceAmount}
                </p>
              </div>
            ))}

            <div className="flex ">
              <p className="text-lg font-medium text-left" style={{ flex: 2 }}>
                Total Order :
              </p>
              <p
                className="text-lg font-medium text-left"
              >{data.orderItems.length}</p>
            </div>

            <div className="flex justify-content-center align-items-center">
              <p className="w-7  border-dashed border-1 "></p>
            </div>
            <p className="text-3xl font-medium text-center">
              Powered By {data.brandName}
            </p>
          </div>
        </div>

        <div className="ml-4 cursor-pointer" onClick={() => window.print()}>
          <img
            src={"Icons/printer.png"}
            style={{
              width: 65,
            }}
          />
        </div>
      </div>
      {/* Menu component */}
      <StoreMenu setVisible={setVisible} visible={visible} />
      <ButtonLink />
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            .print-section, .print-section * {
              visibility: visible;
            }
            .print-section {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              page-break-after: always;
            }
              @page {
              size: 80mm auto;
              margin: 2mm;
            }
          }
        `}
      </style>
    </div>
  );
};

export default OrderDeliveredComponentMenu;
